function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, FormControl, FormHelperText, Grid, TextField } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { useConfiguration } from '../../contexts';
import { AdornmentIcon } from '../AdornmentIcon';
import { PasswordToggle } from '../PasswordToggle';
import { PasswordRequirements } from './PasswordRequirements';
export var PasswordFieldByConfig = function(props) {
    var name = props.name, label = props.label, error = props.error, requirements = props.requirements, showPasswordRequirement = props.showPasswordRequirement, errorLabel = props.errorLabel, setIsValid = props.setIsValid;
    var passwordComplexity = useConfiguration().passwordComplexity;
    var _useTestId = useTestId(), getTestId = _useTestId.getTestId, getTestIdProps = _useTestId.getTestIdProps;
    var _useState = _sliced_to_array(useState(false), 2), isPasswordVisible = _useState[0], setIsPasswordVisible = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isShowRequirements = _useState1[0], setIsShowRequirements = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isValidatingRequirements = _useState2[0], setIsValidatingRequirements = _useState2[1];
    return /*#__PURE__*/ _jsx(Grid, {
        size: {
            xs: 12
        },
        children: /*#__PURE__*/ _jsx(Box, {
            children: /*#__PURE__*/ _jsx(Controller, {
                name: name,
                render: function(param) {
                    var field = param.field, isSubmitting = param.formState.isSubmitting, fieldState = param.fieldState;
                    var _fieldState_error;
                    var _passwordComplexity_requiredLength;
                    return /*#__PURE__*/ _jsxs(FormControl, {
                        fullWidth: true,
                        children: [
                            /*#__PURE__*/ _jsx(TextField, _object_spread({
                                fullWidth: true,
                                type: isPasswordVisible ? 'text' : 'password',
                                label: label,
                                disabled: isSubmitting,
                                variant: "standard",
                                autoCapitalize: "off",
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(PasswordToggle, {
                                                isShowPassword: isPasswordVisible,
                                                setPasswordVisible: setIsPasswordVisible
                                            }),
                                            fieldState.error ? /*#__PURE__*/ _jsx(AdornmentIcon, {
                                                fieldState: fieldState,
                                                text: errorLabel
                                            }) : null
                                        ]
                                    }),
                                    inputProps: {
                                        'data-testid': getTestId("".concat(name, "-password-field"))
                                    },
                                    autoComplete: 'off'
                                },
                                error: !!fieldState.error || !!error,
                                helperText: showPasswordRequirement ? /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        isShowRequirements ? /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, getTestIdProps("".concat(name, "-password-field-requirements"))), {
                                            children: [
                                                /*#__PURE__*/ _jsx(FormHelperText, {
                                                    error: true,
                                                    children: (_fieldState_error = fieldState.error) === null || _fieldState_error === void 0 ? void 0 : _fieldState_error.message
                                                }),
                                                /*#__PURE__*/ _jsx(PasswordRequirements, {
                                                    minChar: (_passwordComplexity_requiredLength = passwordComplexity === null || passwordComplexity === void 0 ? void 0 : passwordComplexity.requiredLength) !== null && _passwordComplexity_requiredLength !== void 0 ? _passwordComplexity_requiredLength : 6,
                                                    requirements: requirements !== null && requirements !== void 0 ? requirements : [],
                                                    setIsValid: setIsValid,
                                                    validating: isValidatingRequirements,
                                                    actualValue: field.value
                                                })
                                            ]
                                        })) : null,
                                        error === null || error === void 0 ? void 0 : error.message
                                    ]
                                }) : null,
                                sx: {
                                    '& input::-ms-reveal, & input::-ms-clear': {
                                        display: 'none'
                                    }
                                },
                                onFocus: function(_e) {
                                    return setIsShowRequirements(true);
                                },
                                onKeyUp: function(_e) {
                                    return setIsValidatingRequirements(true);
                                }
                            }, field)),
                            fieldState.error && !isShowRequirements ? /*#__PURE__*/ _jsx(FormHelperText, {
                                error: true,
                                children: fieldState.error.message
                            }) : null
                        ]
                    });
                }
            })
        })
    });
};
